import React from 'react';
import styled from 'styled-components';
import {convertToDecimal} from '../../AccountOverview/index';
import {displayValue} from '../../AccountOverview/indexDisplayValue';
import {isNullOrUndefined} from '../../../../../../../../util/utils';
import {useUserPreferences} from '../../../../../../../../util/customHooks';

export default function NumberColumn(params) {
	const value = !isNullOrUndefined(params.value) ? convertToDecimal(params.value, false, true) : 0;
	const userPreferences = useUserPreferences();
	const numberFormated = displayValue(
		value,
		false,
		false,
		false,
		undefined,
		1,
		undefined,
		undefined,
		undefined,
		userPreferences
	);

	return <StyledNumberColumn className="StyledNumberColumn">{numberFormated}</StyledNumberColumn>;
}

const StyledNumberColumn = styled.section`
	display: flex;
	justify-content: flex-end;
	font-size: var(--px-14);
	font-weight: 400;
	line-height: var(--px-22);
	width: auto;
	max-width: 90%;
`;
